module.exports = __webpack_public_path__ + "static/media/MotherCarolineAcademy.a510e72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/MotherCarolineAcademy.jpg
// module id = 744
// module chunks = 0